import React from 'react';

import './fcmg-complex.scss';

import zakzakImage from '../../../f/img/target/fmcg/zakzak.png'
import bbImage from '../../../f/img/target/fmcg/bb.png'
import coolImage from '../../../f/img/target/fmcg/cool.png'
import granImage from '../../../f/img/target/fmcg/gran.png'
import revImage from '../../../f/img/target/fmcg/rev.png'
import toolImage from '../../../f/img/target/fmcg/tool.png'
import voshImage from '../../../f/img/target/fmcg/vosh.png'

import zakzakSVG from '../../../f/img/target/fmcg/zakzak.svg'
import coolSVG from '../../../f/img/target/fmcg/cool.svg'
import toolSVG from '../../../f/img/target/fmcg/tool.svg'
import revSVG from '../../../f/img/target/fmcg/rev.svg'
import voshSVG from '../../../f/img/target/fmcg/vosh.svg'
import bbSVG from '../../../f/img/target/fmcg/bb.svg'
import granSVG from '../../../f/img/target/fmcg/gran.svg'



const DecorFMCGComplex = () => {

    return (
        <>
            <div className='line-2' style={{ marginTop: '60px' }}>
                <a
                    href="https://www.artlebedev.ru/spass-group/"
                    target='_blank'
                    rel='noreferrer'
                >
                    <div className='circle-item-decor'>
                        <div className='circle-image-wrapper-decor'>
                            <div
                                className='circle-image-decor'
                                style={{ backgroundImage: `url(${zakzakImage})` }}
                            />
                        </div>
                        <img
                            className='circle-svg-text-decor'
                            src={zakzakSVG}
                            alt=''
                        />
                    </div>
                </a>

                <a
                    href="https://www.artlebedev.ru/krutoyar/"
                    target='_blank'
                    rel='noreferrer'
                >
                    <div className='circle-item-decor'>
                        <div className='circle-image-wrapper-decor'>
                            <div
                                className='circle-image-decor'
                                style={{ backgroundImage: `url(${coolImage})` }}
                            />
                        </div>
                        <img
                            className='circle-svg-text-decor'
                            src={coolSVG}
                            alt=''
                        />
                    </div>
                </a>
            </div>

            <div className='line-3'>
                <a
                    href="https://www.artlebedev.ru/bibicall/"
                    target='_blank'
                    rel='noreferrer'
                >
                    <div className='circle-item-decor'>
                        <div className='circle-image-wrapper-decor'>
                            <div
                                className='circle-image-decor'
                                style={{ backgroundImage: `url(${bbImage})` }}
                            />
                        </div>
                        <img
                            className='circle-svg-text-decor'
                            src={bbSVG}
                            alt=''
                        />
                    </div>
                </a>

                <a
                    href="https://www.artlebedev.ru/tulskaya-ptitsefabrika/"
                    target='_blank'
                    rel='noreferrer'
                >
                    <div className='circle-item-decor'>
                        <div className='circle-image-wrapper-decor'>
                            <div
                                className='circle-image-decor'
                                style={{ backgroundImage: `url(${toolImage})` }}
                            />
                        </div>
                        <img
                            className='circle-svg-text-decor'
                            src={toolSVG}
                            alt=''
                        />
                    </div>
                </a>

                <a
                    href="https://www.artlebedev.ru/gran-re/"
                    target='_blank'
                    rel='noreferrer'
                >
                    <div className='circle-item-decor'>
                        <div className='circle-image-wrapper-decor'>
                            <div
                                className='circle-image-decor'
                                style={{ backgroundImage: `url(${granImage})` }}
                            />
                        </div>
                        <img
                            className='circle-svg-text-decor'
                            src={granSVG}
                            alt=''
                        />
                    </div>
                </a>
                
            </div>

            <div className='line-2'>
            
                <a
                    href="https://www.artlebedev.ru/rev/"
                    target='_blank'
                    rel='noreferrer'
                >
                    <div className='circle-item-decor'>
                        <div className='circle-image-wrapper-decor'>
                            <div
                                className='circle-image-decor'
                                style={{ backgroundImage: `url(${revImage})` }}
                            />
                        </div>
                        <img
                            className='circle-svg-text-decor'
                            src={revSVG}
                            alt=''
                        />
                    </div>
                </a>

                <a
                    href="https://www.artlebedev.ru/woshi-woshi/"
                    target='_blank'
                    rel='noreferrer'
                >
                    <div className='circle-item-decor'>
                        <div className='circle-image-wrapper-decor'>
                            <div
                                className='circle-image-decor'
                                style={{ backgroundImage: `url(${voshImage})` }}
                            />
                        </div>
                        <img
                            className='circle-svg-text-decor'
                            src={voshSVG}
                            alt=''
                        />
                    </div>
                </a>
            </div>
        </>
    );
}

export default DecorFMCGComplex;
